import { isAfter, isWithinInterval, parse, parseISO } from 'date-fns';

export type ActiveRangeData = {
  activeFrom: string;
  activeTo: string | null;
};

export function getActiveDataForParsedStartDate<Data extends ActiveRangeData>(
  allData: Data[],
  parsedStartDate: Date
): Data[] {
  // Ladder/reference datum activeTo date example: 2024-01-01T00:00:00+13:00
  return allData.filter((datum) => {
    // If the ladder/reference datum activeFrom date is after the start date,
    // skip it:
    if (isAfter(parseISO(datum.activeFrom), parsedStartDate)) return false;

    // If there is no activeTo field set, we are assuming that the ladder/
    // reference datum is unique (and therefore may be displayed):
    if (datum.activeTo === null) return true;

    return isWithinInterval(parsedStartDate, {
      start: parseISO(datum.activeFrom),
      end: parseISO(datum.activeTo)
    });
  });
}

/**
 * The backend returns some extra ladders/reference data, so we need to reduce
 * these down to just the ladders/reference data for each year for each active
 * date range.
 */
export function getActiveDataForStartDate<Data extends ActiveRangeData>(
  allData: Data[],
  startDate: string
): Data[] {
  // Parsed version of the test instance start date. Example: 2024-01-24 00:00:00
  const parsedStartDate = parse(startDate, 'yyyy-MM-dd HH:mm:ss', new Date());

  return getActiveDataForParsedStartDate(allData, parsedStartDate);
}
